// @flow

import React from 'react';
import {
  ColorTile, Title, Stock, Price, FromPrice,
} from './atoms';
import { Flex, Box } from '../../../../../grid';
import type { Props } from '../../types';

const ConfigColor = ({
  color,
  title,
  stock,
  price,
  fromPrice,
  active,
  twoToneColor,
  twoToneTitle,
  postfix,
}: Props) => (
  <Flex alignItems="center">
    <ColorTile color={color} twoToneColor={twoToneColor} active={active || false} />
    <Box ml="0.75rem">
      <Flex alignItems="baseline">
        <Title>
          {title}
          {twoToneTitle && ` / ${twoToneTitle}`}
        </Title>
        <Stock amount={stock} />
      </Flex>
      <FromPrice amount={Number(fromPrice)} />
      <Price
        amount={Number(price)}
        postfix={postfix}
      />
    </Box>
  </Flex>
);

ConfigColor.defaultProps = {
  selected: false,
  postfix: null,
};

export default ConfigColor;
